export default __webpack_public_path__ + "static/media/bubbles.1c40ce9c.png";